
import React from 'react';
import { AffiliateUserLimitsManagement } from '@/components/affiliate/AffiliateUserLimitsManagement';
import { useIsMobile } from '@/hooks/use-mobile';

export const ManageUserLimitsPage = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`space-y-${isMobile ? '6' : '8'} ${isMobile ? 'px-4 py-4' : ''}`}>
      <div>
        <h1 className={`${isMobile ? 'text-2xl' : 'text-3xl'} font-bold`}>
          Manage User Limits
        </h1>
        <p className={`text-muted-foreground mt-1 ${isMobile ? 'text-sm' : ''}`}>
          Allocate Market Analysis usage limits to your referred users
        </p>
      </div>
      
      <AffiliateUserLimitsManagement />
    </div>
  );
};

export default ManageUserLimitsPage;
